import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { cn } from '../lib/cn'

type Variant = 'primary' | 'accent' | 'ghost' | 'outline' | 'danger'

const VARIANTS: Record<Variant, string> = {
  primary: 'bg-st-primary text-white hover:bg-st-primary-700',
  accent: 'bg-st-accent text-white hover:bg-st-accent-700',
  ghost: 'bg-transparent text-st-text hover:bg-st-surface-2',
  outline: 'border border-st-line bg-st-surface text-st-text hover:bg-st-surface-2',
  danger: 'bg-st-danger text-white hover:opacity-90',
}

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  children: ReactNode
}

export function Button({ variant = 'primary', className, children, ...rest }: ButtonProps) {
  return (
    <button
      className={cn(
        'inline-flex min-h-11 items-center justify-center gap-2 rounded-st-md px-4 text-sm font-medium transition disabled:cursor-not-allowed disabled:opacity-50',
        VARIANTS[variant],
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  )
}
